var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sf-circle-icon',_vm._g({attrs:{"disabled":_vm.disabled}},_vm.$listeners),[_c(_vm.chevronIcon,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }